module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "feedback-modal",
    style: (_vm.style)
  }, [_c('div', {
    staticClass: "feedback-modal__content"
  }, [_vm._t("default"), _vm._v(" "), _c('div', {
    staticClass: "feedback-modal__x-button",
    on: {
      "click": _vm.close
    }
  }, [_vm._v("X")])], 2)])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-07916b33"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/app/components/common/feedbackModal/FeedbackModal.vue
// module id = 1799
// module chunks = 0